/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum Db_connectionEnum {
  "up" = "up",

  "down" = "down"
}

// required attributes
const AppInfoR = t.interface({});

// optional attributes
const AppInfoO = t.partial({
  db_connection: enumType<Db_connectionEnum>(
    Db_connectionEnum,
    "db_connection"
  ),

  environment: t.string,

  name: t.string,

  version: t.string
});

export const AppInfo = t.intersection([AppInfoR, AppInfoO], "AppInfo");

export type AppInfo = t.TypeOf<typeof AppInfo>;
